import { ConditionalProperties } from 'Automations/nodeDefinitions/conditions'
import { IntermediateNodeWithConditionalProperties } from 'Automations/nodeDefinitions/helpers/presentationToConductorWorkflow'

/**
 * Returns every conditional property the switch can see — i.e. the union of
 * all `conditionalProperties` from upstream nodes, with closer nodes winning
 * for property-name collisions. The switch wires every one of these into the
 * runtime `$` context so that operator function strings can map from context
 * to whichever paths they need without having to declare them up front.
 */
export const resolveSwitchConditionalProperties = ({
  upstreamNodes
}: {
  upstreamNodes: IntermediateNodeWithConditionalProperties[]
}): ConditionalProperties =>
  upstreamNodes.reduce<ConditionalProperties>(
    (acc, node) => ({ ...acc, ...node.conditionalProperties }),
    {}
  )
